// =============================================================================
// Sport linker of the event form: a toggle + sport dropdown that marks an
// event as a workout so past occurrences are logged under Fitness.
// =============================================================================

import React from 'react';
import { Trophy } from 'lucide-react';
import { useTranslation } from '../../lib/i18n';

const SportLinker = ({ sports, linkedSportName, setLinkedSportName }) => {
  const { t } = useTranslation();
  const enabled = !!linkedSportName;

  return (
    <div>
      <div className="flex items-center justify-between">
        <label className="text-sm font-medium text-gray-700 flex items-center gap-1">
          <Trophy size={14} className="text-gray-500" />
          {t('calendar.linkSport')}
        </label>
        <button
          type="button"
          onClick={() =>
            setLinkedSportName(enabled ? '' : sports[0]?.name || '')
          }
          disabled={sports.length === 0 && !enabled}
          className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
            enabled ? 'bg-primary-600' : 'bg-gray-300'
          } disabled:opacity-50`}
        >
          <span
            className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
              enabled ? 'translate-x-6' : 'translate-x-1'
            }`}
          />
        </button>
      </div>

      {enabled && sports.length > 0 && (
        <select
          className="input mt-2"
          value={linkedSportName}
          onChange={(e) => setLinkedSportName(e.target.value)}
        >
          {sports.map((sport) => (
            <option key={sport.id} value={sport.name}>
              {sport.name}
            </option>
          ))}
        </select>
      )}

      {sports.length === 0 && (
        <p className="text-xs text-gray-400 mt-1">
          {t('calendar.linkSportNoSports')}
        </p>
      )}

      {enabled && (
        <p className="text-xs text-gray-500 mt-2">
          {t('calendar.linkSportHint')}
        </p>
      )}
    </div>
  );
};

export default SportLinker;
